export const APPCUES_ID = {
    SEGMENTED_METRIC_SELECTOR: 'SEGMENTED_METRIC_SELECTOR',
    RANGE_DATE_PICKER_WITH_ARROW: 'RANGE_DATE_PICKER_WITH_ARROW',
};

export const TEXT_CONSTANTS = {
    subtitleDashboard: 'Monitor your key metrics and keep track of your goals.',
    titleDashboard: 'Overview',
};
